import React from "react";
import { SettingsRow } from "../SettingsRow";
import styled from "styled-components";
import { useArtistContext } from "Components/ArtistProvider";
import { Fields } from "./Fields";
import { Body1 } from "melodies-source/Text";
import { Caption } from "Components";
import { ArtistGroupTypeArray } from "@max/common/dist/artists";

export const AdvancedSettings: React.FC = () => {
  const {
    artistGroupDoc,
    privateSettings,
    privateUMG,
    privateWMG,
    brandPartnership,
  } = useArtistContext();
  const artistGroupData = artistGroupDoc?.data();
  const privateSettingsData = privateSettings?.data();

  return (
    <SettingsRow
      title={"Advanced Settings"}
      description={
        <>
          Update MAX Artist ID, Spotify ID, or Sort Order. Enable Post-Show
          Email and Partner Opt-Ins.
        </>
      }
    >
      <Container>
        <Fields
          title="Admin Access Fields"
          fields={[
            {
              ref: brandPartnership?.ref,
              component: "launch",
              label: "Brand Partnerships",
              text: (
                <BrandPartnershipsTextContainer>
                  <Body1>Enable</Body1>
                  <Caption>(This cannot be disabled once saved)</Caption>
                </BrandPartnershipsTextContainer>
              ),
              key: "brandPartnerships",
              value: brandPartnership?.exists() ?? false,
            },
            {
              ref: artistGroupDoc?.ref,
              component: "text-input",
              type: "number",
              label: "MAX Artist ID",
              placeholder: "Paste ID here",
              key: "maxArtistId",
              value: `${artistGroupData?.maxArtistId || ""}`,
            },
            {
              component: "select",
              label: "Group Type",
              key: "groupType",
              value: artistGroupData?.groupType || "Waiting on Classification",
              options: ArtistGroupTypeArray,
              ref: artistGroupDoc?.ref,
            },
            {
              component: "partner-opt-ins",
              label: "Partner Opt-Ins",
              key: "partnerOptIns",
              value: {
                umg: privateUMG?.data()?.uiVisible || false,
                wmg: privateWMG?.data()?.uiVisible || false,
              },
              options: [
                {
                  value: "umg",
                  label: "Universal Music Group",
                  ref: privateUMG?.ref,
                },
                {
                  value: "wmg",
                  label: "Warner Music Group",
                  ref: privateWMG?.ref,
                },
              ],
            },
            {
              ref: privateSettings?.ref,
              component: "select",
              label: "Post Show Email",
              key: "postShowEmail",
              value: privateSettingsData?.postShowEmail || "",
              options: [
                { value: "default", label: "Default" },
                { value: "disabled", label: "Disabled" },
              ],
            },
            {
              ref: artistGroupDoc?.ref,
              component: "text-input",
              type: "number",
              label: "Sort Order",
              placeholder: "Paste Order here",
              key: "sortOrder",
              value: `${artistGroupData?.sortOrder || ""}`,
            },
            {
              ref: artistGroupDoc?.ref,
              component: "text-input",
              label: "Spotify Artist ID",
              placeholder: "Paste ID here",
              key: "spotifyArtistId",
              value: artistGroupData?.spotifyArtistId || "",
            },
          ]}
        />
      </Container>
    </SettingsRow>
  );
};

const Container = styled.div`
  display: flex;
  gap: 70px;
  margin-bottom: 15px;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }
`;

const BrandPartnershipsTextContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  position: relative;

  ${Caption} {
    line-height: 21px;
  }

  ${({ theme }) => theme.media.mobile} {
    ${Caption} {
      position: absolute;
      width: 300px;
      bottom: -20px;
    }
  }
`;
